// extracted by mini-css-extract-plugin
module.exports = {"disclaimerContainer":"styles_disclaimerContainer__rduxs","disclaimerInner":"styles_disclaimerInner__LMD0U"};